import script from "./PublicationBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationBanner.vue?vue&type=script&setup=true&lang=js"

import "./PublicationBanner.vue?vue&type=style&index=0&id=3f67756b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f67756b"]])

export default __exports__